import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'lib-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaComponent),
      multi: true
    }
  ],
  standalone: false
})
export class TextareaComponent implements OnInit, ControlValueAccessor {
  @Input() label: string;
  @Input() class: string;
  @Input() disabled: boolean;
  @Input() placeholder: string = '';
  @Input() rows: number = 3;
  @Input() maxlength: number = null;

  value: string;

  onChange = _ => {};

  @Output() onClick = new EventEmitter<Event>();

  get remainingCharacters() {
    return this.maxlength - (this.value?.length || 0);
  }

  constructor() {}

  ngOnInit(): void {}

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {}

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(obj: any): void {
    this.value = obj;
  }
  valueChanged(val: string) {
    this.value = val;
    this.onChange(val);
  }
}
